module.exports = __webpack_public_path__ + "media/3_5.aa486a6c.wav";